<template>
    <div class="row">
        <div class="col fw-bold text-center">
            <h1>{{ time }}</h1>
        </div>
    </div>
    <div v-if="errors" class="alert alert-danger" role="alert">
        <div v-for="(v, k) in errors" :key="k">
            <p v-for="error in v" :key="error">
                {{ error }}
            </p>
        </div>
    </div>
    <hr />

    <div v-if="this.employeeinfo && this.employeeinfo.pinset == 0 && this.loggedin == false">
        <div class="row mb-3">
            <div class="col-3"></div>
            <div class="col-6">
                <p>{{ $trans.get("__JSON__.Provide email address if you want to get responses on your vacation status.")
                    }}</p>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-3"></div>
            <div class="col-6">
                <label for="email">{{ $trans.get("__JSON__.Email address") }}</label>
                <input type="text" class="form-control" v-model="email" id="email" />
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-3"></div>
            <div class="col-6">
                <p>{{ $trans.get("__JSON__.Choose a 4 digit PIN to protect your 'my area'.") }}</p>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-3"></div>
            <div class="col-6">
                <label for="pin">{{ $trans.get("__JSON__.Access PIN") }}</label>
                <input type="password" class="form-control" v-model="pin" id="pin" autocomplete="off" length="4" />
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-3"></div>
            <div class="col-6">
                <button class="btn btn-primary" @click="setPIN">{{ $trans.get("__JSON__.Set PIN") }}</button>
                <a :href="this.loginRoute" class="btn btn-primary float-end">{{ $trans.get("__JSON__.Back") }}</a>
            </div>
        </div>
    </div>

    <div v-if="this.employeeinfo && this.employeeinfo.pinset == 1">
        <div v-if="wrongpin" class="row mb-3">
            <div class="col-5"></div>
            <div class="col-2 alert alert-danger">
                <p>{{ $trans.get("__JSON__.Wrong PIN!") }}</p>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-5"></div>
            <div class="col-2">
                <p>{{ $trans.get("__JSON__.Enter your access pin!") }}</p>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-5"></div>
            <div class="col-2">
                <label for="pin">{{ $trans.get("__JSON__.Access PIN") }}</label>
                <input type="password" class="form-control" v-model="pin" id="pin" autocomplete="off" />
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-5"></div>
            <div class="col-2">
                <button class="btn btn-primary" @click="checkPIN">{{ $trans.get("__JSON__.Login") }}</button>
                <a :href="this.loginRoute" class="btn btn-primary float-end">{{ $trans.get("__JSON__.Back") }}</a>
            </div>
        </div>
    </div>




    <input type="hidden" id="rfid" />
</template>

<script>
import { ref, watch } from "vue";

export default {
    name: "MyLogin",
    props: {
    },
    data() {
        return {
            time: null,
            end: false,
            employeeinfo: null,
            pin: null,
            email: null,
            errors: null,
            wrongpin: false,
            norfid: false,
            loginRoute: "/mylogin"
        }
    },
    created() {
        this.setTime();
        setInterval(this.setTime, 1000);
    },
    mounted() {
        document.addEventListener("keydown", this.onKeydown);
    },
    methods: {
        setTime() {
            this.time = new Date().toLocaleString();
        },
        onKeydown(event) {
            console.log("keydown");
            if (this.norfid) {
                return;
            }

            if (this.end) {
                $('#rfid').val('');
                this.end = false;
            }

            if (!this.end && event.key !== 'Enter') {
                $('#rfid').val($('#rfid').val() + event.key);
            }

            if (event.key === 'Enter') {
                var rfid = parseInt($('#rfid').val());
                this.end = true;
                this.getPIN(rfid);
            }
        },
        getPIN(badgenumber) {
            console.log('getPIN');
            this.loggedin = false;
            this.employeeinfo = null;
            this.errors = null;

            axios
                .get("/api/employeepinset", {
                    params: {
                        badgenumber: badgenumber,
                    },
                })
                .then((resp) => {
                    this.employeeinfo = resp.data;
                    this.email = null;

                    if (this.employeeinfo.error) {
                        if (this.employeeinfo.error == 'not found')
                        this.errors = [['Zugangsnummer nicht gefunden!']];
                    } else {
                        if (this.employeeinfo && this.employeeinfo.email) {
                            this.email = this.employeeinfo.email;
                        }
                        this.norfid = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setPIN() {
            console.log('setPIN');
            axios
                .post("/api/employeepin", {
                    employee_id: this.employeeinfo.id,
                    pin: this.pin,
                    old_pin: this.employeeinfo.pin,
                    email: this.email
                })
                .then((resp) => {
                    console.log(resp.data);
                    if (resp.data.status == "ok") {
                        console.log('set and ok');
                        this.checkPIN();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    console.log(error.response.data.errors);
                    this.errors = error.response.data.errors;
                });

        },
        checkPIN() {
            console.log('checkPIN');
            axios
                .post("/api/mypinlogin", {
                    employee_id: this.employeeinfo.id,
                    pin: this.pin,
                })
                .then((resp) => {
                    if (resp.data.status == "ok") {
                        console.log('checked and ok');
                        window.location.href = "/my/home?terminal=1";
                    } else {
                        this.wrongpin = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });

        },

    }
}
</script>

<style lang="scss"></style>
